import Vue from 'vue';
import axios from 'axios';
import Constants from '@/plugins/constants';
const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  error: '',
  error400: false,
  successFlag: false,
  token: '',
  generalTriageQuestions: null,
  totalPages: 0,
  totalRecords: 0,
  generalTriageQuestion: null,
  errorStatus: null,
};
const getters = {
  getApiLoad_31: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  set_error400(state, error) {
    state.error400 = error;
  },
  SET_Status(state, status) {
    state.successFlag = status;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  SET_GeneralTriageQuestions(state, generalTriageQuestions) {
    state.generalTriageQuestions = generalTriageQuestions;
  },
  SET_GeneralTriageQuestion(state, generalTriageQuestion) {
    state.generalTriageQuestion = generalTriageQuestion;
  },
};
const actions = {
  errorGeneralTriageQuestion({ commit }, temperror) {
    var error = temperror;
    if (error) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
            commit('set_error400', false);
          } else if (error.response.status == 400) {
            commit('SET_errorStatus', false);
            commit('set_error400', true);
          } else {
            commit('SET_errorStatus', false);
            commit('set_error400', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      } else {
        commit('SET_errorStatus', false);
        commit('set_error400', false);
        commit('SET_Error', 'خطا در برقراری ارتباط با سرور');
      }
      commit('SET_Status', false);
    } else {
      commit('SET_Error', 'خطا امنیتی');
    }
  },
  getGeneralTriageQuestions({ commit, dispatch, rootState }) {
    return apiClient
      .get('/GeneralTriageQuestions/Root', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_GeneralTriageQuestions', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorGeneralTriageQuestion', error);
      });
  },
  getGeneralTriageQuestionsWithId({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/GeneralTriageQuestions/ById?triageQuestionId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_GeneralTriageQuestions', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorGeneralTriageQuestion', error);
      });
  },
  addGeneralTriageQuestion({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/GeneralTriageQuestions', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_GeneralTriageQuestions', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorGeneralTriageQuestion', error);
      });
  },
  addGeneralTriageQuestionRoot({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/GeneralTriageQuestions/Root', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorGeneralTriageQuestion', error);
      });
  },
  getGeneralTriageQuestion({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/GeneralTriageQuestions/ById?triageQuestionId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_GeneralTriageQuestion', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorGeneralTriageQuestion', error);
      });
  },
  getGeneralTriageQuestionWithDetail({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/GeneralTriageQuestions/ByIdWithDetails?triageQuestionId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_GeneralTriageQuestion', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorGeneralTriageQuestion', error);
      });
  },
  editGeneralTriageQuestion({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/GeneralTriageQuestions/Edit', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorGeneralTriageQuestion', error);
      });
  },
  deleteGeneralTriageQuestion({ commit, dispatch, rootState }, id) {
    return apiClient
      .post(
        '/GeneralTriageQuestions/Remove?triageQuestionId=' + id,
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorGeneralTriageQuestion', error);
      });
  },
};
export default {
  mutations,
  getters,
  state,
  actions,
};
